import { connect } from 'react-redux';
import SelectCandidatesFormView from './select_candidates_form_view';
import { getCurrentUser } from '../../../../../reducer';

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state),
  organizationId: getCurrentUser(state).getIn(['staffOrganization', 'id']),
});

const mapDispatchToProps = {};

const SelectCandidatesFormContainer = connect(mapStateToProps, mapDispatchToProps)(SelectCandidatesFormView);

export default SelectCandidatesFormContainer;
